(function() {

   angular.module('e360')
      .directive('locationLookup', locationLookupDirective);

   function locationLookupDirective() {
      return {
         restrict: 'A',
         scope: {
            onPickPlace: '&'
         },
         link: locationLookupDirectiveLink
      };

      function locationLookupDirectiveLink(scope, element, attrs) {
         var input = element[0];

         var autocomplete = new google.maps.places.Autocomplete(input);
         autocomplete.addListener('place_changed', onPlaceChanged);

         function onPlaceChanged() {
            var place = autocomplete.getPlace();

            // notify place change inside angular digest loop
            scope.$apply(function() {
               notifyPlaceChange(place);
            });
         }

         function notifyPlaceChange(place) {
            if (!place.geometry) {
               return;
            }

            var streetNumber = findAddressComponent('street_number', true);
            var locality = findAddressComponent('locality', true);
            var result = {
               point: [place.geometry.location.lat(), place.geometry.location.lng()],
               placeId: place.place_id,
            };

            result.address = findAddressComponent('route');
            if (streetNumber) {
               result.address = streetNumber + ' ' + result.address;
            }

            result.city = findAddressComponent('postal_town', true);
            if (result.city) {
               result.address2 = locality;
            } else {
               result.city = locality;
            }

            result.countryCode = findAddressComponent('country');
            result.country = findAddressComponent('country', true);
            
            // The Philippines has both regions (top-level) and provinces (secondary-level). 
            // Provinces are typically found in administrative_area_level_2, but this is not always the case.
            if (result.countryCode == 'PH') {
               let stateCodeAreaLevel2 = findAddressComponent('administrative_area_level_2');
               result.stateCode = stateCodeAreaLevel2 ? stateCodeAreaLevel2 : findAddressComponent('administrative_area_level_1');
            } else {
               result.stateCode = findAddressComponent('administrative_area_level_1');
            }

            result.postalCode = findAddressComponent('postal_code');

            if (scope.onPickPlace) {
               scope.onPickPlace({$place: result});
            }

            function findAddressComponent(componentName, long) {
               var result = _.find(place.address_components, function (addrComp) {
                  return _.contains(addrComp.types, componentName);
               });
               if (result) {
                  return long ? result.long_name : result.short_name;
               }
               return null;
            }
         }
      }
   }

})();